import React from 'react';

function ContactUs() {
    
    return (
   		<div>
	  		<div className="container-fluid">
	    		<div className="col-md-8" >
	    			<h3>Contact Us</h3>
	    		</div>
    		</div>
    		<div className="container-fluid">
				<div class="col-lg-12 alert alert-secondary " role="alert">
					<strong>
  					Need access or forgot your password <br/>
					Contact us ! ( 24/5 Support [Monday - Friday] )<br/>
					Phone: US +1  212-896-2830 opt 9<br/>
					Email: support@nyse.com
					</strong>
				</div>
    		</div>
   		</div>
    );
}

export { ContactUs };